import { dateToServer } from 'helpers/formatters/date';
import { CalculationFrequency } from 'modules/BenchmarkForm';
import { BenchmarkTypes } from 'types/Benchmark';

function mapTimeWindow(timeWindow: any) {
  return {
    ...timeWindow,
    fromDate: dateToServer(new Date(timeWindow.fromDate)),
  };
}

const parseBoolean = (value: string | boolean): boolean => {
  switch (typeof value) {
    case 'string':
      return JSON.parse(value);

    case 'boolean':
    default:
      return value;
  }
};

export function getBody(originalValues: any, newValues: any) {
  const timeWindows = newValues.timeWindows
    ? newValues.timeWindows.map(mapTimeWindow)
    : [];

  return {
    id: originalValues?.id,
    name: newValues.name,
    typeId: BenchmarkTypes.CompositeReturn,
    calculationFrequencyId:
      newValues.calculationFrequency?.id ?? newValues.calculationFrequencyId,
    numberOfDaysInYearId:
      newValues.numberOfDaysInYearId !== undefined
        ? Number(newValues.numberOfDaysInYearId)
        : undefined,
    baseCurrencyCode: newValues.baseCurrencyCode,
    isLagged: parseBoolean(newValues.isLagged) ? true : false,
    customLagDate: newValues.customLagDate || null,
    description: newValues.description || null,
    portfolioAnalyticsCalendarId:
      newValues.calculationFrequencyId === CalculationFrequency.day ||
      newValues.calculationFrequency?.id === CalculationFrequency.day
        ? newValues.portfolioAnalyticsCalendarId
        : undefined,
    performanceVariationCode: newValues.performanceVariationCode,
    includeBookedValues: parseBoolean(newValues.includeBookedValues)
      ? true
      : false,
    timeWindows,
  };
}
